module.exports = __webpack_public_path__ + "img/banner2.5817d7d3.png";